(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/user/register', {}, {});
    }
})();
